import { LanguageService } from 'src/app/services';
import { InsuranceService } from './../../shared/services/insurance.service';
import { ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SmsModalData } from '../../models';
import { ApiService, AuthService } from '../../services';
import { LoadingService } from '../../shared/services/loading.service';


@Component({
  selector: 'app-sms-modal',
  templateUrl: './sms-modal.component.html',
  styleUrls: ['./sms-modal.component.scss']
})
export class SmsModalComponent implements OnInit {

  public formGroup: UntypedFormGroup;

  public code: string;
  public phone: string;

  public isLoading = false;

  public result = { statusCode: 0, statusMessage: '' };


  public langs = [];

  public isRegistered = true;
  timeLeft = 180;
  interval;
  resendAvailable: boolean;
  registerInProgress: boolean;

  constructor(
    public dialogRef: MatDialogRef<SmsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SmsModalData,
    public API: ApiService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private translate: TranslateService,
    public Auth: AuthService,
    private _loadingService: LoadingService,
    private route: ActivatedRoute,
    private insuranceService: InsuranceService,
    private languageService: LanguageService) {

    this.translate.get(['sms_verification']).subscribe(t => {
      this.langs = t;
    });

  }

  ngOnInit() {
    this.dialogRef.afterClosed()
      .subscribe(
        () => {
          clearInterval(this.interval);
        });
    this.formGroup = new UntypedFormGroup({
      phone: new UntypedFormControl('',
        [
          Validators.required,
        ]),
      code: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(4)
      ])
    });
    this.phone = this.data.userData.phone;
    // this.phone = '995597985566';
    this.formGroup.get('phone').setValue(this.phone);
    this.sendCode();
  }

  registerUser(buttonForGtag: HTMLButtonElement): void {
    if (!this.isValid('code')) {
      return;
    }
    if (this.data.isActivating) {
      this.dialogRef.close({ code: this.formGroup.get('code').value });
      return;
    }
    this.registerInProgress = true;
    this.data.userData.SmsCode = this.code;
    this._loadingService.setApplicationLoading(true);
    this.API.registerUser(this.data.userData).subscribe(
      res => {
        this._loadingService.setApplicationLoading(false);
        if (res && res.hasOwnProperty('access_token')) {
          delete this.data.userData.Password;
          if (this.data.isPromoUser) {
            this.Auth.setUserData({
              accessToken: res['access_token'],
              refreshToken: res['refresh_token']
            }, 0, this.data.userData.Phone, this.data.userData, this.data.isPromoUser);
          } else {
            this.Auth.setUserData({
              accessToken: res['access_token'],
              refreshToken: res['refresh_token']
            }, 0, this.data.userData.Phone, this.data.userData, false, this.data.pharma);
          }

          const isInsuranceBubble = this.route.snapshot.paramMap.get('insurance');
          if (isInsuranceBubble === 'insurance') {
            this.insuranceService.insuranceProviderDoctorBubbleLogic(this.languageService.cLang);
          }
        }
        this.registerInProgress = false;
        buttonForGtag.click()
        //
        this.result.statusCode = 1;
        this.result.statusMessage = this.translate.instant('successfully-registered');
        this.dialogRef.close(this.result);
        // this.initIntercom();
      },
      error => {
        this._loadingService.setApplicationLoading(false);
        this.registerInProgress = false;
        this.result.statusCode = 0;
        this.result.statusMessage = error.error.Error.ErrorMessage;
      }
    );
  }

  closeDialog(code: string) {
    this.dialogRef.close(code);
  }

  sendCode(): void {
    if (this.formGroup.get('phone').invalid) {
      return;
    }
    this.resendAvailable = false;
    this.isLoading = true;
    this.data.userData.Phone = this.phone;
    this.API.sendSms(this.phone, this.data.userData.index, this.data.userData.isDoctor, this.data.userData.recaptcha).subscribe(
      res => {
        this.startCountdown();
        if (res) {
        }
        this.result.statusCode = 1;
        this.code = '';
        this.data.type = 1;
      },
      error => {
        this.isLoading = false;
        this.startCountdown();
      }
    );
  }

  startCountdown() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.resendAvailable = true;
        this.timeLeft = 180;
        clearInterval(this.interval);
      }
    }, 1000);
  }

  resend(): void {
    this.startCountdown();
    this.data.type = 2;
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.formGroup.controls[controlName].hasError(errorName);
  };

  public isValid = (controlName: string) => {
    return this.formGroup.controls[controlName].status != 'INVALID';
  };

  onCloseConfirm() {
    this.dialogRef.close('Confirm');
  }

  onCloseCancel() {
    this.dialogRef.close('Cancel');
  }

}
